import { render } from "./SubHero.vue?vue&type=template&id=4ee475b8&scoped=true"
import script from "./SubHero.vue?vue&type=script&lang=js"
export * from "./SubHero.vue?vue&type=script&lang=js"

import "./SubHero.vue?vue&type=style&index=0&id=4ee475b8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ee475b8"

export default script